import { CircleCheck, Info } from "lucide-react";
import { Checkbox, Select, Space, Text } from "@mantine/core";
import React from "react";
import { formList } from "@mantine/form";
import { DEFAULT_EMPLOYEE_CONFIG } from "../utils/constants";
import EmployerImporterReferenceFieldTableStyles from "../assets/EmployerImporterReferenceFieldTableStyles";

type EmployerImporterReferenceFieldTableProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  relatedColumn: string;
  name: string;
  isTag: boolean;
  index: number;
  data: string[];
};

const EmployerImporterReferenceFieldTable: React.FC<
  EmployerImporterReferenceFieldTableProps
> = ({ form, name, relatedColumn, isTag, index, data }) => {
  const { classes, cx } = EmployerImporterReferenceFieldTableStyles();

  const isFound = DEFAULT_EMPLOYEE_CONFIG.find((it) =>
    Object.is(relatedColumn, it.value)
  );

  const selectedColumns = form.values.columnHeaders.map(
    (it: { relatedColumn: string }) => it.relatedColumn
  );

  const columnToMatchValues = DEFAULT_EMPLOYEE_CONFIG.filter(
    (it) => !selectedColumns.includes(it.value)
  );

  return (
    <div
      className={cx(classes.container, {
        [classes.unMatchContainer]: !isFound,
      })}
    >
      <div className={classes.topSection}>
        <div className={classes.descriptorBar}>
          <div
            className={cx(classes.descriptionTags, {
              [classes.unMatchDescriptionTags]: !isFound,
            })}
          >
            {isFound ? (
              <CircleCheck
                style={{
                  color: "#94d82d",
                }}
                size={16}
              />
            ) : (
              <Info
                style={{
                  color: "#ff922b",
                }}
                size={16}
              />
            )}
            <Text
              className={cx(classes.descriptionStatus, {
                [classes.descriptionMatchStatus]: isFound,
              })}
            >
              {isFound ? "Matched" : "Unmatched"}
            </Text>
          </div>
          <div>
            <Checkbox
              name={`columnHeaders-${name}-isTag`}
              label="Tag"
              size="xs"
              checked={isTag}
              onChange={({ currentTarget }) => {
                const { checked } = currentTarget;
                const { columnHeaders } = form.values;
                columnHeaders[index] = {
                  ...form.values.columnHeaders[index],
                  isTag: checked,
                };
                form.setFieldValue("columnHeaders", formList(columnHeaders));
              }}
            />
          </div>
        </div>
        <Space h="xs" />
        <Text className={classes.text}>Match to:</Text>
        <Select
          key={name}
          name={`columnHeaders-${name}-relatedColumn`}
          placeholder="Match To"
          data={isFound ? [isFound] : columnToMatchValues}
          defaultValue={relatedColumn}
          clearable
          onChange={(value) => {
            const { columnHeaders } = form.values;
            columnHeaders[index] = {
              ...form.values.columnHeaders[index],
              relatedColumn: value || "",
            };
            form.setFieldValue("columnHeaders", formList(columnHeaders));
          }}
        />
        <Space h="xl" />
      </div>
      <div className={classes.bottomSection}>
        <div className={classes.headerRow}>
          <Text className={classes.header}>{name}</Text>
        </div>
        {data.map((it, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={classes.row} key={`${it}-${i}`}>
            <Text className={classes.rowLabel}>{it}</Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmployerImporterReferenceFieldTable;
